import { Box } from '@mui/material';

import { selectImpactCo2AnswersImported } from '@/domain/impact-co2/impact-co2.selectors';
import { translate } from '@/ui/i18n';

import { ImpactQuestionContext } from '../ImpactQuestionContext';
import { Co2QuizFormData } from './Co2QuizFormData';
import { QuizFormSeparator } from './components/QuizFormSeparator';
import { ImpactForm } from './ImpactForm';

export function Co2QuizImportedAnswers({
  projectId,
  form,
}: {
  projectId: number;
  form: Co2QuizFormData;
}) {
  return (
    <Box>
      {form.sections.map((section) => (
        <Box
          key={section.sectionKey}
          id={`${section.sectionKey.toLowerCase()}-form`}
        >
          <QuizFormSeparator
            label={translate(`Co2.Sections.${section.sectionKey}`)}
          />
          {section.questions.map((category) => (
            <Box key={category}>
              <ImpactQuestionContext.Provider
                key={category}
                value={{
                  panelOpen: false,
                  hideCompleted: false,
                  answersSelectorOverride: selectImpactCo2AnswersImported({
                    sector: form.sector,
                    category: category,
                  }),
                }}
              >
                <ImpactForm
                  projectId={projectId}
                  sector={form.sector}
                  category={category}
                />
              </ImpactQuestionContext.Provider>
            </Box>
          ))}
        </Box>
      ))}
    </Box>
  );
}
